import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { Section } from "../Section";
import { CTAButton } from "../CTAButton";
export function Guarantee() {
  return <Section tone="cream" data-id="element-154" data-mp="24n86iiamogxt">
      <div className="rounded-[28px] border-2 border-dashed border-berry/50 bg-white p-6 text-center md:p-12" data-id="element-155" data-mp="24myekp60vzph">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full bg-berry text-white" data-id="element-156" data-mp="29eyjyx4v3ktg">
          <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-157" data-mp="2echwnslwvpja" />
          <span className="mt-0.5 text-[12px] font-extrabold uppercase tracking-wider" data-id="element-158" data-mp="2jbbefx88e2p9">7 days</span>
        </div>
        <h2 className="mt-6 font-serif text-[28px] font-bold leading-tight text-ink md:text-4xl" data-id="element-159" data-mp="2oc8v25dleoon">
          Your 7-day “try it risk-free” guarantee
        </h2>
        <div className="mt-5 space-y-4 text-[17px] leading-relaxed text-muted" data-id="element-160" data-mp="tx6beob860tn">
          <p data-id="element-161" data-mp="tziz7i3nz5em">
            You have 7 full days to open Nail Course In A Box™, explore every volume, customize the templates and see
            whether it fits your teaching style.
          </p>
          <p className="font-semibold text-ink" data-id="element-162" data-mp="3snjacux7qohw">Use it. Customize it. Look through the templates.</p>
          <p data-id="element-163" data-mp="3nsn8l326cmrl">
            If you decide it's not right for you, simply request a refund within 7 days. No complicated process. No
            awkward questions.
          </p>
          <p className="font-serif text-[21px] font-bold italic text-berry" data-id="element-164" data-mp="3dy3nhq0sz37h">You take the risk out of trying it.</p>
        </div>
      </div>
      <CTAButton label="Try Nail Course In A Box™ risk-free" data-id="element-165" data-mp="aftt0x9ev8sx" />
    </Section>;
}